<div #chartContainer class="w-100 h-100 notranslate">
    <div echarts
         [options]="options"
         (chartInit)="onChartInit($event)"
         (chartClick)="onChartClick($event)"
         class="w-100 h-100"
         style="height: 700px;">
    </div>
</div>
